import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

export const GrayBackground = styled.div`
  background-color: ${COLORS.lightestGray};
  width: 100%;
`;
